import { Quote } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { DIRECTORS, DIRECTORS_VISION } from "../data/content";

export const Directors = () => (
  <section id="directors" data-testid="directors-section" className="py-20 md:py-32 bg-ivory scroll-mt-20">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <SectionHeading
        chapter="05"
        overline="Meet Our Directors"
        title="The Hands That Guide the House"
        center
      />

      <div className="grid md:grid-cols-2 gap-12 md:gap-20 max-w-5xl mx-auto -mt-4 md:-mt-8">
        {DIRECTORS.map((d, i) => (
          <Reveal key={i} delay={0.12 * i}>
            <article data-testid={`director-card-${i + 1}`} className="group">
              <div className="relative">
                <div className={`absolute w-full h-full border border-gold/40 rounded-sm ${i % 2 ? "-bottom-4 -right-4" : "-top-4 -left-4"}`} aria-hidden="true" />
                <div className="relative overflow-hidden rounded-sm">
                  <img
                    src={d.photo}
                    alt={d.alt}
                    loading="lazy"
                    className="w-full h-[380px] md:h-[460px] object-cover object-top transition-transform duration-[900ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-royal-deep/70 to-transparent" aria-hidden="true" />
                </div>
              </div>
              <div className="mt-7 text-center">
                <h3 className="font-serif text-3xl text-royal-deep">{d.name}</h3>
                <p className="mt-1 text-xs tracking-[0.3em] uppercase text-gold-muted font-medium">{d.designation}</p>
                <p className="mt-4 text-base font-light italic text-charcoal/60 leading-relaxed max-w-sm mx-auto">
                  &ldquo;{d.message}&rdquo;
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-16 md:mt-24 max-w-3xl mx-auto text-center">
        <Quote size={26} strokeWidth={1} className="mx-auto text-gold mb-5" />
        <p data-testid="directors-vision" className="font-serif italic text-xl md:text-2xl text-royal leading-relaxed">
          {DIRECTORS_VISION}
        </p>
      </Reveal>
    </div>
  </section>
);
